import React from "react";
import ClauseStaticDocument from "../ClauseStaticDocument";

const styles = "\n    :root {\n      --primary: #0d3b8e;\n      --primary-dark: #081f4a;\n      --primary-light: #e8f0fe;\n      --accent: #1a6ef5;\n      --text-main: #1a1a2e;\n      --text-sub: #4a4a68;\n      --text-muted: #8888a8;\n      --border: #e2e6f0;\n      --bg: #f5f7fc;\n      --white: #ffffff;\n      --new-badge: #e8f4ff;\n      --new-badge-text: #1a6ef5;\n      --warn: #fff8f0;\n      --warn-border: #f0a030;\n    }\n\n    * { margin: 0; padding: 0; box-sizing: border-box; }\n    html { scroll-behavior: smooth; }\n    body {\n      font-family: 'Noto Sans KR', 'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif;\n      background: var(--bg);\n      color: var(--text-main);\n      font-size: 15px;\n      line-height: 1.8;\n    }\n\n    /* ── Top Bar ── */\n    .topbar {\n      position: sticky; top: 0; z-index: 100;\n      background: var(--primary-dark);\n      padding: 0 32px;\n      display: flex; align-items: center; justify-content: space-between;\n      height: 52px;\n      box-shadow: 0 2px 12px rgba(0,0,0,0.18);\n    }\n    .topbar-brand { font-size: 14px; font-weight: 700; color: #fff; letter-spacing: 1.5px; }\n    .btn-prev {\n      display: inline-flex; align-items: center; gap: 6px;\n      background: rgba(255,255,255,0.12);\n      border: 1px solid rgba(255,255,255,0.22);\n      border-radius: 6px; color: #fff;\n      font-size: 12.5px; font-weight: 600;\n      padding: 6px 14px; cursor: pointer;\n      transition: background 0.2s; font-family: inherit;\n    }\n    .btn-prev:hover { background: rgba(255,255,255,0.22); }\n    .btn-prev svg { width: 14px; height: 14px; }\n\n    /* ── Layout ── */\n    .page-wrap { max-width: 860px; margin: 0 auto; padding: 48px 24px 80px; }\n\n    /* ── Page Header ── */\n    .page-header {\n      background: linear-gradient(135deg, var(--primary-dark) 0%, #1a3a80 100%);\n      border-radius: 16px; padding: 40px 44px; margin-bottom: 36px; color: #fff;\n    }\n    .page-header .badge {\n      display: inline-block;\n      background: rgba(255,255,255,0.15);\n      border: 1px solid rgba(255,255,255,0.3);\n      border-radius: 20px; padding: 4px 14px;\n      font-size: 11.5px; font-weight: 600;\n      letter-spacing: 1px; margin-bottom: 16px;\n    }\n    .page-header h1 { font-size: 24px; font-weight: 700; line-height: 1.4; margin-bottom: 12px; }\n    .page-header .meta {\n      font-size: 13px; color: rgba(255,255,255,0.65);\n      display: flex; gap: 20px; flex-wrap: wrap;\n    }\n    .page-header .meta span { display: flex; align-items: center; gap: 5px; }\n\n    /* ── TOC ── */\n    .toc {\n      background: var(--white); border: 1px solid var(--border);\n      border-radius: 12px; padding: 24px 28px; margin-bottom: 36px;\n    }\n    .toc-title { font-size: 13px; font-weight: 700; color: var(--text-muted); letter-spacing: 1px; text-transform: uppercase; margin-bottom: 14px; }\n    .toc ol { list-style: none; display: grid; grid-template-columns: 1fr 1fr; gap: 6px 24px; }\n    .toc ol li a {\n      font-size: 13.5px; color: var(--text-sub); text-decoration: none;\n      display: flex; align-items: center; gap: 8px;\n      padding: 4px 0; transition: color 0.15s;\n    }\n    .toc ol li a:hover { color: var(--accent); }\n    .toc ol li a .toc-num {\n      font-size: 11px; font-weight: 700; color: var(--accent);\n      background: var(--primary-light); border-radius: 4px;\n      width: 22px; height: 22px;\n      display: flex; align-items: center; justify-content: center; flex-shrink: 0;\n    }\n    @media (max-width: 600px) { .toc ol { grid-template-columns: 1fr; } }\n\n    /* ── Chapter Divider ── */\n    .chapter-divider {\n      display: flex; align-items: center; gap: 14px;\n      margin: 36px 0 16px;\n    }\n    .chapter-divider .ch-label {\n      background: var(--primary-dark);\n      color: #fff; font-size: 12px; font-weight: 700;\n      padding: 5px 16px; border-radius: 20px;\n      white-space: nowrap; letter-spacing: 0.5px;\n    }\n    .chapter-divider .ch-line { flex: 1; border-top: 2px solid var(--border); }\n\n    /* ── Section Card ── */\n    .section-card {\n      background: var(--white); border: 1px solid var(--border);\n      border-radius: 14px; margin-bottom: 16px; overflow: hidden;\n    }\n    .section-head {\n      display: flex; align-items: center; gap: 14px;\n      padding: 20px 28px; border-bottom: 1px solid var(--border);\n      background: #fafbff;\n    }\n    .section-num {\n      background: var(--primary); color: #fff;\n      font-size: 12px; font-weight: 700;\n      min-width: 80px; height: 30px;\n      border-radius: 8px;\n      display: flex; align-items: center; justify-content: center; flex-shrink: 0;\n      letter-spacing: 0.2px;\n    }\n    .section-title { font-size: 15.5px; font-weight: 700; color: var(--primary-dark); }\n    .badge-new {\n      display: inline-flex; align-items: center;\n      background: var(--new-badge); color: var(--new-badge-text);\n      font-size: 10.5px; font-weight: 700;\n      padding: 3px 9px; border-radius: 20px; margin-left: 8px; letter-spacing: 0.3px;\n    }\n    .section-body { padding: 22px 28px; }\n\n    /* ── Typography ── */\n    .section-body p {\n      font-size: 14.5px; color: var(--text-sub); line-height: 1.85; margin-bottom: 14px;\n    }\n    .section-body p:last-child { margin-bottom: 0; }\n\n    /* Numbered items (1) 2) ...) */\n    .item-list { margin-bottom: 14px; }\n    .item-list:last-child { margin-bottom: 0; }\n    .item-row {\n      display: flex; gap: 10px; margin-bottom: 10px;\n      font-size: 14.5px; color: var(--text-sub); line-height: 1.85;\n    }\n    .item-row:last-child { margin-bottom: 0; }\n    .item-num { flex-shrink: 0; font-weight: 600; color: var(--primary); min-width: 28px; }\n\n    /* Circle items ①②③ */\n    .item-circle { flex-shrink: 0; font-weight: 700; color: var(--primary); min-width: 22px; }\n\n    /* Sub list 가. 나. 다. */\n    .sub-list { padding-left: 4px; margin-top: 8px; }\n    .sub-row {\n      display: flex; gap: 8px; margin-bottom: 6px;\n      font-size: 14px; color: var(--text-sub); line-height: 1.8;\n    }\n    .sub-label { flex-shrink: 0; color: var(--text-muted); font-weight: 500; min-width: 22px; }\n\n    /* Deep sub list ① ② ③ (under 항목) */\n    .deep-list { padding-left: 4px; margin-top: 8px; }\n    .deep-row {\n      display: flex; gap: 8px; margin-bottom: 6px;\n      font-size: 14px; color: var(--text-sub); line-height: 1.8;\n    }\n    .deep-num { flex-shrink: 0; color: var(--primary); min-width: 22px; font-weight: 600; }\n\n    /* Numbered deep sub 1. 2. 3. */\n    .num-list { padding-left: 4px; margin-top: 8px; }\n    .num-row {\n      display: flex; gap: 8px; margin-bottom: 6px;\n      font-size: 14px; color: var(--text-sub); line-height: 1.8;\n    }\n    .num-label { flex-shrink: 0; color: var(--text-muted); font-weight: 500; min-width: 22px; }\n\n    /* ── Sub section heading ── */\n    .sub-heading {\n      font-size: 14.5px; font-weight: 700; color: var(--primary-dark);\n      margin: 18px 0 10px; padding-left: 10px;\n      border-left: 3px solid var(--accent);\n    }\n    .sub-heading:first-child { margin-top: 0; }\n\n    /* ── Tables ── */\n    .tbl-wrap {\n      overflow-x: auto; margin: 12px 0 16px;\n      border-radius: 8px; border: 1px solid var(--border);\n    }\n    .tbl-wrap:last-child { margin-bottom: 0; }\n    table { width: 100%; border-collapse: collapse; font-size: 13.5px; }\n    thead th {\n      background: var(--primary-dark); color: #fff;\n      padding: 10px 14px; font-weight: 600; text-align: left; white-space: nowrap;\n    }\n    tbody td {\n      padding: 10px 14px; border-bottom: 1px solid var(--border);\n      color: var(--text-sub); vertical-align: top; line-height: 1.7;\n    }\n    tbody tr:last-child td { border-bottom: none; }\n    tbody tr:nth-child(even) td { background: #f8f9fc; }\n\n    /* ── Note box ── */\n    .note-box {\n      background: #f0f7ff; border: 1px solid #c5dcff;\n      border-radius: 8px; padding: 14px 18px;\n      font-size: 13.5px; color: var(--text-sub); line-height: 1.8; margin-top: 14px;\n    }\n\n    /* ── Addendum box ── */\n    .addendum-box {\n      background: var(--primary-light); border: 1px solid #bbd0ff;\n      border-radius: 10px; padding: 20px 24px; margin-top: 4px;\n    }\n    .addendum-row {\n      display: flex; gap: 10px; margin-bottom: 10px;\n      font-size: 14.5px; color: var(--text-sub); line-height: 1.85;\n    }\n    .addendum-row:last-child { margin-bottom: 0; }\n    .addendum-num { flex-shrink: 0; font-weight: 700; color: var(--primary); min-width: 28px; }\n\n    /* ── Effective date strip ── */\n    .effective-strip {\n      display: flex; gap: 24px; flex-wrap: wrap;\n      background: var(--primary-light); border: 1px solid #bbd0ff;\n      border-radius: 8px; padding: 14px 20px;\n      font-size: 14px; color: var(--primary-dark); font-weight: 500; margin-top: 4px;\n    }\n    .effective-strip span { display: flex; align-items: center; gap: 6px; }\n    .effective-strip .label { font-weight: 400; color: var(--text-muted); }\n\n    /* ── Modal ── */\n    .modal-overlay {\n      display: none; position: fixed; inset: 0;\n      background: rgba(10,20,50,0.55); z-index: 200;\n      align-items: flex-start; justify-content: center; padding: 20px;\n    }\n    .modal-overlay.open { display: flex; }\n    .modal {\n      background: var(--white); border-radius: 16px;\n      max-width: 620px; width: 100%; max-height: 88vh; overflow-y: auto;\n      box-shadow: 0 24px 60px rgba(0,0,0,0.22);\n      animation: modalIn 0.22s ease;\n    }\n    @keyframes modalIn {\n      from { opacity: 0; transform: translateY(16px) scale(0.98); }\n      to   { opacity: 1; transform: translateY(0) scale(1); }\n    }\n    .modal-header {\n      background: linear-gradient(135deg, var(--primary-dark), #1a3a80);\n      padding: 24px 28px 20px; border-radius: 16px 16px 0 0;\n      display: flex; justify-content: space-between; align-items: flex-start;\n    }\n    .modal-header h2 { font-size: 17px; font-weight: 700; color: #fff; line-height: 1.4; }\n    .modal-header p  { font-size: 12.5px; color: rgba(255,255,255,0.6); margin-top: 4px; }\n    .modal-close {\n      background: rgba(255,255,255,0.15); border: none; border-radius: 6px;\n      color: #fff; width: 30px; height: 30px; font-size: 18px; cursor: pointer;\n      display: flex; align-items: center; justify-content: center;\n      flex-shrink: 0; margin-left: 12px;\n    }\n    .modal-body { padding: 24px 28px 28px; }\n    .modal-section { margin-bottom: 24px; }\n    .modal-section:last-child { margin-bottom: 0; }\n    .modal-section-title {\n      font-size: 13.5px; font-weight: 700; color: var(--primary-dark);\n      margin-bottom: 12px; display: flex; align-items: center; gap: 8px;\n    }\n    .modal-section-title .num {\n      background: var(--accent); color: #fff; font-size: 11px; font-weight: 700;\n      width: 20px; height: 20px; border-radius: 4px;\n      display: flex; align-items: center; justify-content: center; flex-shrink: 0;\n    }\n    .modal-tbl { width: 100%; border-collapse: collapse; font-size: 13px; border-radius: 8px; overflow: hidden; border: 1px solid var(--border); }\n    .modal-tbl thead th { background: var(--primary-dark); color: #fff; padding: 9px 13px; font-weight: 600; text-align: left; }\n    .modal-tbl tbody td { padding: 10px 13px; border-bottom: 1px solid var(--border); color: var(--text-sub); vertical-align: top; line-height: 1.65; }\n    .modal-tbl tbody tr:last-child td { border-bottom: none; }\n    .modal-tbl tbody tr:nth-child(even) td { background: #f8f9fc; }\n    .check-list { list-style: none; }\n    .check-list li {\n      display: flex; gap: 9px; font-size: 13.5px; color: var(--text-sub);\n      line-height: 1.75; padding: 7px 0; border-bottom: 1px dashed var(--border);\n    }\n    .check-list li:last-child { border-bottom: none; }\n    .check-list li .icon { color: var(--accent); flex-shrink: 0; margin-top: 2px; }\n\n    @media (max-width: 640px) {\n      .page-header { padding: 28px 22px; }\n      .section-head, .section-body { padding: 16px 18px; }\n      .modal-body { padding: 18px 18px 22px; }\n      .topbar { padding: 0 16px; }\n    }\n    .clause-version-nav {\n      display: flex; flex-wrap: wrap; gap: 8px; justify-content: flex-end; margin: 0 0 16px;\n    }\n    .clause-version-btn {\n      appearance: none; border: 1px solid #cbd5e1; background: #fff; color: #334155;\n      border-radius: 999px; padding: 9px 16px; font-size: 13px; font-weight: 600; cursor: pointer;\n      font-family: inherit;\n    }\n    .clause-version-btn.is-active { border-color: #2563eb; background: #2563eb; color: #fff; }\n    .toc ol li a { white-space: nowrap; }\n    .page-header,\n    .page-header .badge,\n    .page-header h1,\n    .page-header .meta,\n    .page-header .meta span {\n      color: #fff !important;\n    }\n  ";

type UseV11DocumentProps = {
  modal?: React.ComponentProps<typeof ClauseStaticDocument>["modal"];
  mode?: "scheduled" | "current" | "previous";
  currentVersionRoute?: string;
  scheduledVersionRoute?: string | null;
};

const UseV11Document = ({
  modal,
  mode = "scheduled",
  currentVersionRoute = "/clause/use/v1.1",
  scheduledVersionRoute = null,
}: UseV11DocumentProps) => {
  return (
    <ClauseStaticDocument styles={styles} modal={modal}>
    <div className="page-wrap">
      <div className="clause-version-nav">
        {mode === "previous" ? (
          <>
            {scheduledVersionRoute && (
              <button type="button" className="clause-version-btn" data-route={scheduledVersionRoute}>
                {"예정 버전"}
              </button>
            )}
            <button type="button" className="clause-version-btn" data-route={currentVersionRoute}>
              {"현재 버전"}
            </button>
            <button type="button" className="clause-version-btn" data-route="/clause/use/v1.0">
              {"이전 버전"}
            </button>
          </>
        ) : mode === "current" ? (
          <>
            {scheduledVersionRoute && (
              <button type="button" className="clause-version-btn" data-route={scheduledVersionRoute}>
                {"예정 버전"}
              </button>
            )}
            <button type="button" className="clause-version-btn is-active" data-route={currentVersionRoute}>
              {"현재 버전"}
            </button>
            <button type="button" className="clause-version-btn" data-route="/clause/use/v1.0">
              {"이전 버전"}
            </button>
          </>
        ) : (
          <>
            <button type="button" className="clause-version-btn is-active" data-route="/clause/use">
              {"예정 버전"}
            </button>
            <button type="button" className="clause-version-btn" data-route="/clause/use/v1.0">
              {"현재 버전"}
            </button>
          </>
        )}
      </div>
      <div className="page-header">
        <div className="badge">
          {"서비스 이용약관"}
        </div>
        <h1>
          {"비즈팅 서비스 이용약관"}
        </h1>
      </div>
      <div className="toc">
        <div className="toc-title">
          {"목차"}
        </div>
        <ol>
          <li>
            <a href="#ch1">
              <span className="toc-num">
                {"1장"}
              </span>
              {"총칙 (제1조~제5조)"}
            </a>
          </li>
          <li>
            <a href="#ch2">
              <span className="toc-num">
                {"2장"}
              </span>
              {"서비스 이용 (제6조~제22조)"}
            </a>
          </li>
          <li>
            <a href="#ch2-2">
              <span className="toc-num">
                {"2장2"}
              </span>
              {"N-Pass 서비스 (제22조의2~4)"}
            </a>
          </li>
          <li>
            <a href="#ch3">
              <span className="toc-num">
                {"3장"}
              </span>
              {"포인트 관련 규정 (제23조~제29조)"}
            </a>
          </li>
          <li>
            <a href="#ch4">
              <span className="toc-num">
                {"4장"}
              </span>
              {"계약 해지 및 이용 제한 (제30조~제31조)"}
            </a>
          </li>
          <li>
            <a href="#ch5">
              <span className="toc-num">
                {"5장"}
              </span>
              {"손해배상 및 면책조항 (제32조~제34조)"}
            </a>
          </li>
          <li>
            <a href="#addendum">
              <span className="toc-num">
                {"부칙"}
              </span>
              {"부칙"}
            </a>
          </li>
        </ol>
      </div>
      <div className="chapter-divider" id="ch1">
        <span className="ch-label">
          {"제1장 총칙"}
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card" id="s1">
        <div className="section-head">
          <div className="section-num">
            {"제 1 조"}
          </div>
          <div className="section-title">
            {"목적"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"본 이용약관(이하 '약관')은 비즈톡 주식회사(이하 '회사')가 운영하는 비즈팅 서비스(이하 '비즈팅' 또는 '서비스')에서 사용하는 지불 및 결제 수단(이하 '비즈팅 포인트')을 사용함에 있어 회사와 이용고객(이하 '회원')간에 비즈팅 포인트에 대한 충전 및 사용에 관해서 상호간 준수해야 할 사항, 이용조건 및 절차와 기타 필요한 제반 사항을 규정함을 목적으로 합니다."}
          </p>
        </div>
      </div>
      <div className="section-card" id="s2">
        <div className="section-head">
          <div className="section-num">
            {"제 2 조"}
          </div>
          <div className="section-title">
            {"용어의 정의"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"이 '약관'에서 사용하는 용어의 정의는 다음과 같습니다."}
          </p>
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                <strong>
                  {"서비스:"}
                </strong>
                {" 비즈팅 서비스는 SKT 회선 이용 고객을 대상으로 타겟팅하여 사업자인 회원의 마케팅 캠페인을 문자메시지 형태로 제공하는 회사의 서비스를 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                <strong>
                  {"회사:"}
                </strong>
                {" 비즈톡 주식회사가 운영하는 온라인서비스 혹은 사업자의 의미로도 사용합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                <strong>
                  {"이용고객:"}
                </strong>
                {" 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                <strong>
                  {"회원:"}
                </strong>
                {" 회사와 서비스 이용계약을 체결하고 회원 아이디를 부여받은 자를 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                <strong>
                  {"아이디(ID):"}
                </strong>
                {" 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 문자와 숫자의 조합입니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(6)"}
              </span>
              <span>
                <strong>
                  {"비밀번호(PW):"}
                </strong>
                {" 회원의 비밀보호를 위하여 회원 자신이 설정한 문자와 숫자의 조합을 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(7)"}
              </span>
              <span>
                <strong>
                  {"운영자:"}
                </strong>
                {" 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람을 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(8)"}
              </span>
              <span>
                <strong>
                  {"해지:"}
                </strong>
                {" 회사 또는 회원이 이용 계약을 해약하는 것을 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(9)"}
              </span>
              <span>
                <strong>
                  {"비즈팅 포인트:"}
                </strong>
                {" 회사가 인정하는 방법을 통하여 생성되며, 회사에서 제공하는 유료 서비스를 이용할 수 있는 사이버 캐시를 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(10)"}
              </span>
              <span>
                <strong>
                  {"충전:"}
                </strong>
                {" '비즈팅 포인트'를 회사에서 제공하는 결제 방식을 통해 일정 금액 단위로 구입하는 것을 말합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(11)"}
              </span>
              <span>
                <strong>
                  {"N-Pass:"}
                </strong>
                {" 비즈팅이 네이버 로그인 플러스의 외부 인증 수단을 통해 수집한 메시지 수신자의 개인정보를 회원(고객사)에게 제 3자 제공하여과 공동으로 처리하고  이를 활용하여 마케팅·회원 유치 및 관리 목적으로 활용할 수 있도록 지원하는 부가 서비스를 말합니다. "}
                <span className="badge-new">
                  {"신설"}
                </span>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(12)"}
              </span>
              <span>
                <strong>
                  {"정보주체:"}
                </strong>
                {" N-Pass 서비스를 통해 개인정보가 수집되는 메시지 수신자를 말합니다. "}
                <span className="badge-new">
                  {"신설"}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s3">
        <div className="section-head">
          <div className="section-num">
            {"제 3 조"}
          </div>
          <div className="section-title">
            {"약관의 적용과 개정"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 본 '약관'을 '홈페이지'에 게시하는 방법으로 공지하며 서비스 이용 신청(계약) 시 이용고객으로부터 '약관'에 대한 동의를 받습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 '약관의 규제에 관한 법률', '정보통신망법' 등 관련법을 위배하지 않는 범위에서 본 '약관'을 개정할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사가 본 '약관'을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 그 적용일자 30일 이전부터 적용일자 전일까지 공지합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사가 전항에 따라 개정 약관을 공지 또는 통지하면서 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 회원에게 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정 약관에 동의한 것으로 봅니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회원이 개정 약관의 적용에 동의하지 않는 경우 회사는 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 계약을 해지할 수 있습니다. 다만, 기존 '약관'을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(6)"}
              </span>
              <span>
                {"새로운 서비스가 개설될 경우 별도의 명시된 설명이 없는 한 본 '약관'에 따라 제공합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(7)"}
              </span>
              <span>
                {"회사는 서비스에 부수하여 타 서비스와 연계한 통합서비스 또는 별도의 서비스 등을 제공할 수 있으며 이용조건 등은 별도로 공지하는 바에 따릅니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s4">
        <div className="section-head">
          <div className="section-num">
            {"제 4 조"}
          </div>
          <div className="section-title">
            {"약관 외 준칙"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"본 '약관'은 회사가 제공하는 서비스에 관하여 별도의 정책 및 운영규칙과 함께 적용됩니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"본 '약관'의 해석은 대한민국 법에 의하여 해석되고 적용되며, '약관'에서 정하지 아니한 사항은 전기통신기본법, 전기통신사업법 및 기타 관계법령 또는 상관례에 따릅니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s5">
        <div className="section-head">
          <div className="section-num">
            {"제 5 조"}
          </div>
          <div className="section-title">
            {"개인정보취급방침의 적용"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 관계 법령이 정하는 바에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해 노력합니다. 이용자 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 '개인정보처리방침'에 따릅니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 회사가 제공하는 서비스의 회원을 대상으로 서비스의 양적·질적 향상을 위하여 회원의 개인 식별이 가능한 개인정보를 회원의 동의를 받아 수집하여 서비스에 이용할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사가 수집하는 개인정보는 서비스의 제공에 필요한 최소한으로 하되, 필요한 경우 자세한 정보를 요구할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 개인정보의 수집 시 관련 법규에 따라 서비스 이용 신청서 또는 계약서 및 '약관'에 그 수집 범위 및 목적을 사전 고지하며 회사의 '개인정보처리방침'에 공개합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회사는 서비스 제공과 관련하여 취득한 회원의 개인정보를 본인의 동의 없이 제3자에게 제공 또는 배포할 수 없으며 상업적 목적으로 사용할 수 없습니다. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우에는 그러하지 아니합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="chapter-divider" id="ch2">
        <span className="ch-label">
          {"제2장 1 서비스 이용"}
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card" id="s6">
        <div className="section-head">
          <div className="section-num">
            {"제 6 조"}
          </div>
          <div className="section-title">
            {"이용계약의 성립"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"서비스 가입 신청 시 본 약관을 읽고 '동의합니다'에 체크 후 '확인' 버튼을 누르면 이 약관에 동의하는 것으로 간주되며 이용계약은 서비스 이용자가 이용신청 동의 후 회사가 승낙함으로써 성립합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s7">
        <div className="section-head">
          <div className="section-num">
            {"제 7 조"}
          </div>
          <div className="section-title">
            {"이용 신청"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"이용 신청은 온라인으로 회사가 요청하는 소정의 가입신청 양식에서 요구하는 사항을 기록하여 신청합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"가입신청양식에 기재하는 모든 회원 정보는 실제 데이터인 것으로 간주하며 실명이나 실제 정보를 입력하지 않은 사용자는 법적인 보호를 받을 수 없으며, 서비스 사용의 제한을 받을 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"타인의 정보를 도용하는 등 부정한 목적과 방법으로 이용신청을 한 회원의 ID는 사전 통지 없이 삭제될 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s8">
        <div className="section-head">
          <div className="section-num">
            {"제 8 조"}
          </div>
          <div className="section-title">
            {"이용신청의 승낙"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 회원이 제2장 7조에서 정한 모든 사항을 정확히 기재하여 이용신청을 하였을 때 특별한 사정이 없는 한 접수 순서대로 이용신청을 승낙합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 다음 각 호에 해당하는 이용신청에 대하여는 승낙을 유보할 수 있고, 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"서비스 관련 설비에 여유가 없는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"회사의 운영상, 사업상 위해 요소 또는 위해 우려가 있는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"기술상 지장이 있는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"라."}
                    </span>
                    <span>
                      {"기타 회사의 사정으로 이용 승낙이 곤란한 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 다음 각 호에 해당하는 이용신청에 대하여는 승낙을 제한할 수 있습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"실명이 아닌 정보 또는 다른 사람의 정보를 사용하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"이용 신청 시 필요내용을 허위로 기재하여 신청한 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"라."}
                    </span>
                    <span>
                      {"기타 회사가 정한 이용신청요건이 미비된 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"마."}
                    </span>
                    <span>
                      {"신용정보의 이용과 보호에 관한 법률에 의한 PC통신, 인터넷서비스의 채무불이행자로 등록되어 있는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"바."}
                    </span>
                    <span>
                      {"기타 회원으로 등록하는 것이 서비스의 기술상 또는 업무 수행상 현저히 지장이 있다고 판단하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"사."}
                    </span>
                    <span>
                      {"회원으로 등록하는 것이 회사의 정책상 적합하지 않다고 판단되는 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s9">
        <div className="section-head">
          <div className="section-num">
            {"제 9 조"}
          </div>
          <div className="section-title">
            {"회원정보의 변경"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"회원은 개인정보관리를 통해 언제든지 개인정보를 열람하고 수정할 수 있습니다. 회원은 이용신청 시 기재한 사항이 변경되었을 경우에는 온라인으로 수정을 해야 하고 관리 소홀로 인하여 발생하는 서비스 이용상의 손해 또는 제3자에 의한 부정이용 등에 대한 책임은 이용자 본인에게 있으며, 회사는 그에 대한 책임을 일절 지지 않습니다."}
          </p>
        </div>
      </div>
      <div className="section-card" id="s10">
        <div className="section-head">
          <div className="section-num">
            {"제 10 조"}
          </div>
          <div className="section-title">
            {"서비스의 이용개시"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 회원의 이용 신청을 승낙한 때부터 서비스를 개시합니다. 단, 일부 서비스의 경우에는 지정된 일자부터 서비스를 개시합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공시하거나 이를 통지합니다. 단, 불가피한 사정에 의한 경우에는 사후 공지할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s11">
        <div className="section-head">
          <div className="section-num">
            {"제 11 조"}
          </div>
          <div className="section-title">
            {"서비스의 이용시간"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 단, 회사의 업무상이나 기술상의 이유로 서비스가 일시 중지될 수 있고, 또한 운영상의 목적으로 회사가 정한 기간에는 서비스가 일시 중지될 수 있습니다. 이러한 경우 회사는 사전에 이를 공지하며, 부득이한 경우 사후 공지할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 서비스를 일정범위로 분할하여 각 범위별로 이용 가능한 시간을 별도로 정할 수 있으며 이 경우 그 내용을 공지합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s12">
        <div className="section-head">
          <div className="section-num">
            {"제 12 조"}
          </div>
          <div className="section-title">
            {"서비스의 변경 및 중지"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 변경될 서비스의 내용 및 제공일자를 제20조에서 정한 방법으로 회원에게 통지하고 서비스를 변경하여 제공할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"서비스용 설비의 보수 등 공사로 인한 부득이한 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"회원이 회사의 영업 활동을 방해하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 제공에 지장이 있는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"라."}
                    </span>
                    <span>
                      {"서비스 제공을 위하여 회사가 제3자와 체결한 계약의 종료 등 회사의 제반 사정으로 서비스를 유지할 수 없는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"마."}
                    </span>
                    <span>
                      {"서비스 제공을 위한 SKT 망 혹은 서버에 장애가 발생하여 정상적인 서비스 제공에 지장이 있는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"바."}
                    </span>
                    <span>
                      {"기타 천재지변, 국가비상사태 등의 불가항력적 사유가 있는 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"제2항에 의한 서비스 제한·중지의 경우 회사는 제20조에서 정한 방법으로 회원에게 통지합니다. 단, 회사가 통제할 수 없는 사유로 인한 서비스 중단으로 인하여 사전통지가 불가능한 경우에는 그러하지 아니합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 서비스의 변경, 제한이나 중지로 발생하는 문제에 대해서는 책임을 지지 않습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s13">
        <div className="section-head">
          <div className="section-num">
            {"제 13 조"}
          </div>
          <div className="section-title">
            {"문자 전송에 대한 회원의 의무와 책임"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원은 서비스를 통해 문자를 전송할 수 있습니다. 단, 회원의 자격에 따라 제한될 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회원은 본 조의 문자를 이용하여 수신자의 의사에 반하는 광고성 정보를 일시에 다량으로 또는 지속적으로 전송하거나 불법스팸을 전송해서는 안 됩니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s14">
        <div className="section-head">
          <div className="section-num">
            {"제 14 조"}
          </div>
          <div className="section-title">
            {"정보의 제공 및 광고의 게재"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"회사는 서비스를 운영함에 있어 회사의 서비스 관련 각종 정보 및 광고를 서비스 화면에 게재하거나 E-mail 및 SMS, 기타 전자적 매체 활용 등의 방법으로 회원에게 제공할 수 있습니다."}
          </p>
        </div>
      </div>
      <div className="section-card" id="s15">
        <div className="section-head">
          <div className="section-num">
            {"제 15 조"}
          </div>
          <div className="section-title">
            {"게시물 또는 내용물의 삭제"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 회원이 게시하거나 전달하는 서비스의 모든 내용물이 각 호의 경우에 해당한다고 판단되는 경우 사전통지 없이 내용물을 삭제할 수 있으며, 이에 대해 회사는 책임을 지지 않습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"회사, 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등의 유포에 해당하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"범죄적 행위에 결부된다고 객관적으로 인정되는 내용인 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"라."}
                    </span>
                    <span>
                      {"회사 또는 제3자의 저작권 또는 기타 권리를 침해하는 내용인 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"마."}
                    </span>
                    <span>
                      {"회사에서 규정한 게시기간을 초과한 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"바."}
                    </span>
                    <span>
                      {"회사에서 제공하는 서비스와 관련 없는 내용인 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"사."}
                    </span>
                    <span>
                      {"불필요하거나 승인되지 않은 광고, 판촉물인 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"아."}
                    </span>
                    <span>
                      {"기타 관계 법령 및 회사의 지침 등에 위반된다고 판단되는 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 게시물에 관련된 세부이용지침을 별도로 정하여 시행할 수 있으며, 회원은 그 지침에 따라 각종 게시물을 등록하거나 삭제하여야 합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s16">
        <div className="section-head">
          <div className="section-num">
            {"제 16 조"}
          </div>
          <div className="section-title">
            {"게시물의 저작권"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원이 서비스 내에 게시한 게시물의 저작권은 회원이 소유하며 회사는 서비스 내에 이를 게시할 수 있는 권리를 갖습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 게시한 회원의 동의 없이 게시물을 다른 목적으로 사용할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 서비스 고도화를 위하여 회원의 저작물을 동의 하에 가공·게시할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 회원이 서비스 내에 게시한 게시물이 타인의 저작권 등 권리를 침해하더라도 이에 대한 민·형사상의 책임을 부담하지 않습니다. 만일 회원이 타인의 저작권 등 권리를 침해하였음을 이유로 회사가 타인으로부터 손해배상청구 등 이의제기를 받은 경우 회원은 회사의 면책을 위하여 노력하여야 하며, 회사가 면책되지 못한 경우 회원은 그로 인해 회사에 발생한 모든 손해를 부담하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회사는 회원이 서비스를 해지하거나 적법한 사유로 서비스가 해지된 경우 해당 회원이 게시하였던 게시물을 삭제할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(6)"}
              </span>
              <span>
                {"회사가 작성한 저작물에 대한 저작권은 회사에 귀속됩니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(7)"}
              </span>
              <span>
                {"회원은 서비스를 이용하여 얻은 정보를 가공·판매하는 행위 등 서비스에 게재된 자료를 영리 목적으로 이용하거나 제3자에게 이용하게 할 수 없으며, 게시물에 대한 저작권 침해는 관계 법령의 적용을 받습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s17">
        <div className="section-head">
          <div className="section-num">
            {"제 17 조"}
          </div>
          <div className="section-title">
            {"회사의 의무"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 이 약관에서 정한 바에 따라 계속적·안정적으로 서비스를 제공할 의무가 있으며 메시지 시스템이 최상의 상태를 유지하도록 관리하며 전송 데이터의 보안을 위해 최선을 다합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 회원의 개인정보를 본인의 승낙 없이 타인에게 누설·배포하여서는 아니 됩니다. 다만, 제1장 5조 (5)항의 경우에는 예외로 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 통보하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 서비스 제공을 위한 시스템에 장애가 발생하거나 고장 발생 시 그 사실을 전화·메일 등 신속한 방법으로 회원에게 전달하고 복구를 위하여 최선의 조치를 강구합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회사는 회원의 회원정보를 보호하기 위해 보안시스템을 구축 운영하며, '개인정보처리방침'을 공지하고 준수합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(6)"}
              </span>
              <span>
                {"회사가 제공하는 서비스로 인하여 회원에게 손해가 발생한 경우 그러한 손해가 회사의 고의나 중과실에 의해 발생한 경우에 한하여 회사에서 책임을 부담하며, 그 책임의 범위는 통상손해에 한합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(7)"}
              </span>
              <span>
                {"회사는 회원이 서비스 제공 목적에 맞는 이용 여부를 확인하기 위하여 상시적으로 모니터링을 실시하며, '스팸', '불법스팸' 및 '문자피싱'을 전송한 사실을 확인한 경우 한국인터넷진흥원 불법스팸대응센터에 관련 자료를 첨부하여 신고할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s18">
        <div className="section-head">
          <div className="section-num">
            {"제 18 조"}
          </div>
          <div className="section-title">
            {"회원의 의무"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"회원은 하기 사항을 숙지하고, 이를 위반하는 경우에 회사는 회원의 서비스 이용제한 및 적법조치를 포함한 제재를 가할 수 있습니다."}
          </p>
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원은 회사의 직원이나 서비스 운영자를 가장하거나 사칭하여 SMS 발송 또는 연락을 취하는 행위를 할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회원은 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보의 전송 또는 게시 행위를 할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회원은 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위를 할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회원은 재판매의 목적으로 서비스를 이용할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회원은 타인의 결제정보 등을 도용하거나 부정한 행위로 거래를 할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(6)"}
              </span>
              <span>
                {"서비스를 통해 발송되는 모든 메시지는 발송 채널의 주체인 SKT의 검수를 받은 후 승인된 메시지에 한하여 발송하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(7)"}
              </span>
              <span>
                {"아이디와 비밀번호에 관한 모든 관리 책임은 회원에게 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(8)"}
              </span>
              <span>
                {"회원에게 부여된 아이디와 비밀번호의 관리소홀·부정사용에 의하여 발생한 결과에 대한 책임은 회원에게 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(9)"}
              </span>
              <span>
                {"회원은 아이디 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(10)"}
              </span>
              <span>
                {"회원은 서비스의 이용권한, 기타 서비스 이용계약상의 지위를 타인에게 양도·증여할 수 없으며 이를 담보로 제공할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(11)"}
              </span>
              <span>
                {"회원은 회사로부터 특별한 권한을 받지 않고 회사의 클라이언트 프로그램을 변경하거나 회사의 서버를 해킹할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(12)"}
              </span>
              <span>
                {"회원은 기타 불법적이거나 부당한 행위를 할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(13)"}
              </span>
              <span>
                {"회원은 서비스의 본래 목적 외의 용도로 서비스를 이용하여서는 아니 되며 타인의 지적재산권 또는 타인의 사생활을 침해하는 내용을 전송할 목적으로 사용해서는 안 되고 제3자에게 임의로 해당 서비스를 임대하여서도 안 됩니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(14)"}
              </span>
              <span>
                {"회원은 '정보통신망법'에 따른 광고성 정보 전송 시 의무사항 및 회사의 '약관'을 준수하여야 하며, 기타 회사의 업무 수행에 현저한 지장을 초래하는 행위를 하여서는 안 됩니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(15)"}
              </span>
              <span>
                {"회원은 공공의 안녕·질서 또는 미풍양속을 해하는 다음 각 호의 내용으로 메시지를 전송하여서는 안 됩니다.\n            "}
                <div className="deep-list">
                  <div className="deep-row">
                    <span className="deep-num">
                      {"①"}
                    </span>
                    <span>
                      {"범죄 행위를 목적으로 하거나 범죄 행위를 교사하는 내용"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"②"}
                    </span>
                    <span>
                      {"반국가적 행위의 수행을 목적으로 하는 내용"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"③"}
                    </span>
                    <span>
                      {"선량한 풍속, 기타 사회질서를 해하는 내용"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(16)"}
              </span>
              <span>
                {"회원은 '정보통신망법'에 따라 메시지 전송을 위해 이동통신사 가입자의 사전 수신동의를 직접 얻어야 하고, '스팸', '불법스팸' 및 '문자피싱' 전송을 위해 서비스를 이용하여서는 아니 되며, 회사를 통해 전달되는 수신거부 요청에 대해서는 즉각적으로 처리하고 24시간 이내에 처리결과를 회사에 회신하여야 하며 본 항의 위반으로 발생하는 모든 민·형사상의 책임은 회원이 직접 부담해야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(17)"}
              </span>
              <span>
                {"회원은 N-Pass서비스를 이용하는 경우 다음 각 호의 의무를 준수하여야 합니다. "}
                <span className="badge-new">
                  {"신설"}
                </span>
                <div className="num-list">
                  <div className="num-row">
                    <span className="num-label">
                      {"1."}
                    </span>
                    <span>
                      {"회원은 N-Pass 서비스를 통해 공동으로 처리하는 제 3자 제공받은 개인정보 전부 개인정보 일체를 고지된 목적(마케팅·회원 유치 및 관리) 외의 용도로 이용하거나, 제3자에게 재제공하거나, 유상으로 판매하여서는 아니 됩니다."}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"2."}
                    </span>
                    <span>
                      {"회원은 개인정보 유출 방지를 위해 회사가 요구하는 2단계 인증(MFA) 설정, 접근권한 최소화, 마스킹 처리된 화면 이용 등 보안 수칙을 준수하여야 합니다."}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"3."}
                    </span>
                    <span>
                      {"회원은 N-Pass 서비스 사용과 관련하여 회사가 제공하는 '메시지 수신자 전용 개인정보처리방침'을 확인하고 이를 적용하여야 하며, 해당 방침에 명시된 개인정보 보호 의무를 성실히 이행할 책임이 있습니다."}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"4."}
                    </span>
                    <span>
                      {"정보주체의 개인정보 파기(동의 철회 등) 요청 시, 회사의 시스템에서는 해당 정보가 복구 불가능한 방법으로 5일 이내 자동으로 파기됩니다. 회원은 회사로부터 파기 관련 안내 메일을 수신한 경우, 즉시 기존에 다운로드하여 보관 중인 개인정보 파일(엑셀 등)을 복구 불가능한 방법으로 파기하여야 하며, 시스템에서 최신 데이터를 다시 다운로드하여 사용하여야 합니다."}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"5."}
                    </span>
                    <span>
                      {"회원은 N-Pass서비스 종료 또는 서비스 해지 시, 접근 및 활용한 개인정보 전부를 5일 이내에 파기하고 파기 결과를 회사에 통보하여야 합니다."}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"6."}
                    </span>
                    <span>
                      {"회원은 다운로드한 개인정보 파일을 반드시 비밀번호로 암호화하여 보관하여야 하며, 다운로드 시 그 사유를 시스템에 기록하여야 합니다."}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"7."}
                    </span>
                    <span>
                      {"본 조를 위반하거나 관리 소홀로 인하여 발생하는 개인정보 유출·오남용·법령 위반 등 모든 법적 책임 및 손해배상 의무는 회원(고객사)이 전적으로 부담하며, 비즈팅은 이에 대하여 어떠한 책임도 지지 않습니다."}
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s19">
        <div className="section-head">
          <div className="section-num">
            {"제 19 조"}
          </div>
          <div className="section-title">
            {"회원의 ID 및 비밀번호에 대한 의무"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원은 ID 및 비밀번호를 철저히 관리하여야 하며, 관리소홀·부정사용 등에 의하여 발생하는 모든 결과에 대한 책임은 회원 본인이 부담하며, 회사는 이에 대한 책임을 부담하지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회원은 본인의 ID 및 비밀번호를 제3자에게 이용하게 하여서는 아니 되며, 도난 또는 제3자가 사용하고 있음을 인지하는 경우에는 즉시 비밀번호를 변경하고 해당 사실을 회사에 통지하여야 합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s20">
        <div className="section-head">
          <div className="section-num">
            {"제 20 조"}
          </div>
          <div className="section-title">
            {"회원에 대한 통지"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원에 대한 통지를 하는 경우 회사는 회원이 등록한 E-mail 주소 또는 SMS, 기타 전자적 전송매체를 통해 할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 불특정 다수 회원에 대한 통지의 경우 서비스 공지사항 등에 게시함으로써 개별 통지에 갈음할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s21">
        <div className="section-head">
          <div className="section-num">
            {"제 21 조"}
          </div>
          <div className="section-title">
            {"회원의 개인정보보호"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"회사는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관한 사항은 관련법령 및 회사가 정하는 통합개인정보처리방침에 정한 바에 따릅니다."}
          </p>
        </div>
      </div>
      <div className="section-card" id="s22">
        <div className="section-head">
          <div className="section-num">
            {"제 22 조"}
          </div>
          <div className="section-title">
            {"개인정보의 처리 업무 위탁"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"회사는 수집된 개인정보의 처리 업무를 스스로 수행할 것을 원칙으로 하나, 필요한 경우 일부 또는 전부를 회사가 선정한 제3자에게 위탁할 수 있습니다."}
          </p>
        </div>
      </div>
      <div className="chapter-divider" id="ch2-2">
        <span className="ch-label">
          {"제2장의2 N-Pass 서비스 "}
          <span style={{ fontSize: "10px", background: "rgba(255,255,255,0.2)", padding: "2px 7px", borderRadius: "8px", marginLeft: "4px"  }}>
            {"신설"}
          </span>
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card" id="s22-2">
        <div className="section-head">
          <div className="section-num">
            {"제 22 조의2"}
          </div>
          <div className="section-title">
            {"N-Pass의 제공 "}
            <span className="badge-new">
              {"신설"}
            </span>
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 메시지 수신자가 비즈팅 N-Pass기능 페이지에서 개인정보 수집·제공에 동의한 경우, 해당 정보를 수집하여 회원(고객사)에게 제 3자 제공하여 과 공동으로 처리하고 지원하는N-Pass 서비스를 제공합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"N-Pass 서비스는 회원이 별도의 'N-Pass 서비스 이용 및 보안 서약'(이하 '보안 서약')에 동의하고 서비스를 활성화한 경우에만 이용할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 N-Pass 서비스를 통해 제 3자 제공을 위해 공동 처리의 일환으로 수집·활용하는 개인정보의 항목, 목적, 보유 기간 등을 '개인정보처리방침' 및 정보주체의 동의 화면에 명시합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 서비스의 기술적 사정 또는 운영 정책 변경 등으로 인해 N-Pass 서비스의 내용을 변경하거나 중단할 수 있으며, 이 경우 회원에게 사전 통지합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s22-3">
        <div className="section-head">
          <div className="section-num">
            {"제 22 조의3"}
          </div>
          <div className="section-title">
            {"보안 서약 및 서비스 활성화 "}
            <span className="badge-new">
              {"신설"}
            </span>
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원은 N-Pass 서비스를 활성화하기 전에 다음 각 호의 사항을 포함한 보안 서약에 동의하여야 합니다.\n            "}
                <div className="num-list">
                  <div className="num-row">
                    <span className="num-label">
                      {"1."}
                    </span>
                    <span>
                      {"관리자 계정의 2단계 인증(이메일 인증 등 MFA) 필수 적용 및 내부 접근 권한 최소화"}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"2."}
                    </span>
                    <span>
                      {"공동처리하는제 3자 제공받은 정보를 명시된 목적(마케팅·회원 유치) 외 사용 및 외부 유출 금지"}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"3."}
                    </span>
                    <span>
                      {"이용 목적 달성 또는 정보주체의 동의 철회 시 5일 이내 복구 불가능한 방법으로 파기"}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"4."}
                    </span>
                    <span>
                      {"활용하는 데이터를 활용하여 진행하는 모든 활동에 대한 법적 책임이 회원에게 있음을 확인하고, 사고 발생 시 비즈팅이 면책됨에 동의"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"보안 서약에 동의하지 않는 경우 N-Pass 서비스를 이용할 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 보안 서약 이력을 전자적으로 기록·보관하며, 분쟁 발생 시 이를 증거로 활용할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s22-4">
        <div className="section-head">
          <div className="section-num">
            {"제 22 조의4"}
          </div>
          <div className="section-title">
            {"N-Pass 서비스의 이용 제한 및 해지 "}
            <span className="badge-new">
              {"신설"}
            </span>
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 회원이 다음 각 호에 해당하는 경우 N-Pass 서비스의 이용을 즉시 중단하거나 제한할 수 있습니다.\n            "}
                <div className="num-list">
                  <div className="num-row">
                    <span className="num-label">
                      {"1."}
                    </span>
                    <span>
                      {"제18조 제(17)항 또는 보안 서약을 위반한 경우"}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"2."}
                    </span>
                    <span>
                      {"개인정보 유출, 오남용, 불법 이용 등이 확인되거나 의심되는 경우"}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"3."}
                    </span>
                    <span>
                      {"정보주체로부터 개인정보 침해 신고가 접수된 경우"}
                    </span>
                  </div>
                  <div className="num-row">
                    <span className="num-label">
                      {"4."}
                    </span>
                    <span>
                      {"관련 법령을 위반하였거나 위반이 우려되는 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회원이 N-Pass 서비스를 해지하는 경우 해지 시점에 보유 중인 개인정보를 5일 이내에 파기하고 그 결과를 회사에 통보하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사가 서비스를 중단하는 경우 회원에게 사전 통지하며, 회원은 통지 즉시 보유 중인 개인정보를 파기하여야 합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="chapter-divider" id="ch3">
        <span className="ch-label">
          {"제3장 포인트 관련 규정"}
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card" id="s23">
        <div className="section-head">
          <div className="section-num">
            {"제 23 조"}
          </div>
          <div className="section-title">
            {"포인트의 사용"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"충전한 비즈팅 포인트에 대한 차감은 회사가 제공하는 서비스를 이용하는 시점에서 즉시 이루어집니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"정상적이지 않은 방법으로 비즈팅 포인트를 충전하거나 사용한 경우 해당 비즈팅 포인트만큼을 이용자의 비즈팅 포인트에서 강제로 차감할 수 있으며, 서비스 이용을 제한할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s24">
        <div className="section-head">
          <div className="section-num">
            {"제 24 조"}
          </div>
          <div className="section-title">
            {"포인트의 차감"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"충전한 비즈팅 포인트에 대한 차감은 회사가 제공하는 서비스를 이용하는 시점에서 즉시 이루어집니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"정상적이지 않은 방법으로 비즈팅 포인트를 충전하거나 사용한 경우 해당 비즈팅 포인트만큼을 이용자의 비즈팅 포인트에서 강제로 차감할 수 있으며, 서비스 이용을 제한할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s25">
        <div className="section-head">
          <div className="section-num">
            {"제 25 조"}
          </div>
          <div className="section-title">
            {"포인트의 사용제한"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회원은 다음 각호에 해당하는 행위를 하여서는 아니 되며 이를 위반할 경우 회사는 회원에 대하여 비즈팅 포인트 이용을 정지시킬 수 있습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"타인의 이용 아이디 및 비밀번호를 부정하게 사용하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"타인의 명의나 개인정보를 도용하여 서비스를 이용하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"타인의 결제정보 등을 도용하거나 부정한 행위로 거래를 하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"라."}
                    </span>
                    <span>
                      {"비즈팅 포인트 서비스 제공에 지장을 초래하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"마."}
                    </span>
                    <span>
                      {"본 약관에 위반하는 방법으로 비즈팅 포인트 서비스를 이용하는 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"바."}
                    </span>
                    <span>
                      {"기타 법령에 위배되는 행위를 하는 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 비즈팅 포인트 이용을 제한할 경우 이용 제한 내용과 소명 절차를 이용자가 지정한 전자우편, SMS 등으로 통지하여 이용자가 이를 소명할 수 있는 기회를 부여합니다"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s26">
        <div className="section-head">
          <div className="section-num">
            {"제 26 조"}
          </div>
          <div className="section-title">
            {"포인트의 충전방법"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"비즈팅 포인트 충전은 회사가 정한 다양한 결제수단을 이용하여 충전할 수 있습니다"}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"비즈팅 포인트의 충전을 위해 다음과 같은 결제수단이 제공되며, 회사의 사정으로 추가 및 서비스 중지가 될 수 있습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"신용카드"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"계좌이체"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"무통장입금"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사가 제공하는 결제수단은 회사의 운영방침에 따라 이용이 제한될 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사가 제공하는 시스템상의 장애에 의하여 충전이 정상적으로 이루어지지 못한 경우에 비즈팅 포인트로 재충전을 받을 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s27">
        <div className="section-head">
          <div className="section-num">
            {"제 27 조"}
          </div>
          <div className="section-title">
            {"포인트의 유효기간"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"비즈팅 포인트의 유효기간은 충전일 또는 구매일로부터 60개월입니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s28">
        <div className="section-head">
          <div className="section-num">
            {"제 28 조"}
          </div>
          <div className="section-title">
            {"포인트의 환불"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"유효기간이 지난 비즈팅 포인트는 환불받으실 수 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"충전에 해당되는 결제 수단의 승인 취소 또는 결제 수단으로 결제 금액을 재 환원하는 것으로 환불을 대신할 수 있을 경우 회사는 현금 환불을 하지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"아래의 내용에 해당하는 경우 환불 신청을 통해 회사가 정한 절차에 따라 환불을 받을 수 있습니다.\n            "}
                <div className="deep-list">
                  <div className="deep-row">
                    <span className="deep-num">
                      {"①"}
                    </span>
                    <span>
                      {"비즈팅 포인트를 충전했으나 사용할 수 있는 서비스가 전무하며 그에 대한 책임이 전적으로 회사에 있는 경우 (단, 시스템 정기점검 등의 불가피한 경우는 제외)"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"②"}
                    </span>
                    <span>
                      {"비즈팅 포인트 잔액이 남아 있는 상태에서 회원이 변경된 약관에 동의하지 않는다는 이유로 탈퇴하고, 회사가 이를 정당하다고 판단하는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"③"}
                    </span>
                    <span>
                      {"기타 고객의 권리보호를 위하여 회사가 별도로 정한 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"아래 내용에 해당하는 경우 캐시는 자동으로 소멸됩니다.\n            "}
                <div className="deep-list">
                  <div className="deep-row">
                    <span className="deep-num">
                      {"①"}
                    </span>
                    <span>
                      {"회원의 귀책사유로 탈퇴된 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"②"}
                    </span>
                    <span>
                      {"회원의 귀책사유로 탈퇴한 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"③"}
                    </span>
                    <span>
                      {"제18조 (회원의 의무)를 위반하여 탈퇴한 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"환불 신청시 결제금액에 따라 사용건수에 따른 전송요금, 재정경제부에서 고시한에서 규정한 위약금(총 이용료의 10%) 및 PG수수료, 송금비용을 제외한 잔액을 환불하여 드립니다. 단, 위약금 및 PG수수료, 송금비용, 결제금액에 따라 추가 증여된 캐시의 합계는 최소 5,000원입니다. 따라서 5,000원 미만의 캐시는 회원 탈퇴시 자동 소멸됩니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s29">
        <div className="section-head">
          <div className="section-num">
            {"제 29 조"}
          </div>
          <div className="section-title">
            {"포인트의 환불 절차"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"비즈팅 포인트의 환불 절차는 다음과 같습니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"환불 신청 시 이용자는 비즈팅에 환불 신청 접수를 하여야 합니다."}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"환불 신청은 비즈팅 고객센터 메일(tf@biztalk.co.kr)을 통하여 신청하실 수 있습니다."}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"다."}
                    </span>
                    <span>
                      {"회사는 환불 신청 접수 후 환불요청 확인절차를 거쳐 14일 이내에 제3장 28조 (포인트의 환불)에 따라 충전금액 환불을 진행합니다."}
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"다음 사항에 해당될 경우에는 환불이 불가능합니다.\n            "}
                <div className="sub-list">
                  <div className="sub-row">
                    <span className="sub-label">
                      {"가."}
                    </span>
                    <span>
                      {"이벤트 행사 등 무상으로 받은 비즈팅 포인트인 경우"}
                    </span>
                  </div>
                  <div className="sub-row">
                    <span className="sub-label">
                      {"나."}
                    </span>
                    <span>
                      {"비 정상적인 방법으로 포인트를 충전한 경우"}
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="chapter-divider" id="ch4">
        <span className="ch-label">
          {"제4장 계약 해지 및 이용 제한"}
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card" id="s30">
        <div className="section-head">
          <div className="section-num">
            {"제 30 조"}
          </div>
          <div className="section-title">
            {"계약해지"}
          </div>
        </div>
        <div className="section-body">
          <p>
            {"회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 회사의 서비스 페이지를 통해 회사에 해지 신청을 하여야 합니다."}
          </p>
        </div>
      </div>
      <div className="section-card" id="s31">
        <div className="section-head">
          <div className="section-num">
            {"제 31 조"}
          </div>
          <div className="section-title">
            {"이용 제한"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"서비스의 원활한 운영을 위하여 회원이 전송하는 메시지에 대해 일별 또는 월별 전송 허용 건수 및 전송 시간 등을 제한할 수 있으며 개별 메시지에 대한 재전송 횟수를 한정할 수 있습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 회원의 서비스 이용 내용이 다음 각 호에 해당하는 경우 서비스 이용을 제한할 수 있습니다.\n            "}
                <div className="deep-list">
                  <div className="deep-row">
                    <span className="deep-num">
                      {"①"}
                    </span>
                    <span>
                      {"제18조 규정에 의한 회원의 의무를 이행하지 않은 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"②"}
                    </span>
                    <span>
                      {"서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나 수신자의 의사에 반하여 광고성 정보를 지속적으로 전송하는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"③"}
                    </span>
                    <span>
                      {"다른 회원 또는 제3자의 지적재산권을 침해하는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"④"}
                    </span>
                    <span>
                      {"방송통신심의위원회의 시정요구가 있거나 불법선거운동과 관련하여 중앙선거관리위원회의 유권해석을 받은 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑤"}
                    </span>
                    <span>
                      {"타 회원의 아이디를 부정하게 이용하거나 타인의 명예를 손상시키거나 불이익을 주는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑥"}
                    </span>
                    <span>
                      {"서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑦"}
                    </span>
                    <span>
                      {"서비스에 위해를 가하거나 서비스의 건전한 이용을 저해하는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑧"}
                    </span>
                    <span>
                      {"타인의 명의를 이용하여 신청(계약)한 경우 또는 신청서의 내용을 허위로 기재하였거나 허위서류를 첨부하여 이용승낙을 득한 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑨"}
                    </span>
                    <span>
                      {"국익 또는 사회적 공익을 저해할 목적으로 이용되는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑩"}
                    </span>
                    <span>
                      {"메시지 수신자가 '스팸'으로 신고하거나 회원이 발송하는 메시지가 '불법스팸'임이 판명될 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑪"}
                    </span>
                    <span>
                      {"회사의 수신거부 요청 처리에 불성실하여 수신거부 요청 건수가 감소되지 않거나 발송금지를 요청한 메시지 내용이 중복적으로 발송될 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑫"}
                    </span>
                    <span>
                      {"방송통신위원회 또는 한국인터넷진흥원이 '스팸', '불법스팸', '문자피싱' 전송 사실을 확인하여 이용정지를 요청하는 경우"}
                    </span>
                  </div>
                  <div className="deep-row">
                    <span className="deep-num">
                      {"⑬"}
                    </span>
                    <span>
                      {"제18조 제(17)항 또는 보안 서약을 위반하여 개인정보를 오남용·유출하거나 관련 법령을 위반한 경우 "}
                      <span className="badge-new">
                        {"추가"}
                      </span>
                    </span>
                  </div>
                </div>
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 상기 3항 ⑩ 내지 ⑫의 경우 회원에게 전송량 축소, 아이디 중지 등의 방법으로 서비스 이용을 제한할 수 있습니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="chapter-divider" id="ch5">
        <span className="ch-label">
          {"제5장 손해배상 및 면책조항 및 기타조항"}
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card" id="s32">
        <div className="section-head">
          <div className="section-num">
            {"제 32 조"}
          </div>
          <div className="section-title">
            {"손해배상"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 서비스 이용과 관련하여 회사의 귀책사유로 인하여 발생되지 않은 회원의 손실에 관해서는 책임을 지지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회원이 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회원이 서비스를 이용하는 과정에서 행한 불법행위나 본 약관 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우, 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"'정보통신망법'에서 규정한 사항을 위반하여 발생한 손해에 대한 책임은 회사에서 책임지지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회원이 N-Pass 서비스를 통해 활용하는 개인정보를 오남용·유출하거나 관련 법령을 위반하여 정보주체 또는 제3자에게 손해를 입힌 경우, 해당 회원(고객사)이 모든 손해배상 책임을 부담하며 회사는 이에 대하여 어떠한 책임도 지지 않습니다. 회사가 제3자로부터 이의제기·손해배상청구를 받은 경우 회원은 자신의 비용으로 회사를 면책시켜야 합니다. "}
                <span className="badge-new">
                  {"추가"}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s33">
        <div className="section-head">
          <div className="section-num">
            {"제 33 조"}
          </div>
          <div className="section-title">
            {"면책조항"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사는 제12조에 의거 회원의 서비스 이용을 제한하는 경우 이로 인해 발생할 수 있는 회원의 손해 등에 대해서는 책임이 면제됩니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(3)"}
              </span>
              <span>
                {"회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도·정확성 등 내용에 관하여는 책임을 지지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(4)"}
              </span>
              <span>
                {"회사는 회원이 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(5)"}
              </span>
              <span>
                {"회사는 회원 상호간 또는 회원과 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(6)"}
              </span>
              <span>
                {"회사는 제30조에 의거 이용고객의 서비스 이용을 제한하는 경우 이로 인해 발생할 수 있는 이용고객의 손해 등에 대해서는 책임이 면제됩니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(7)"}
              </span>
              <span>
                {"회사는 N-Pass 서비스를 통해 회원에게 제 3자 제공한 과 공동처리하는 개인정보의 활용 과정에서 발생하는 손해에 대하여 책임을 지지 않습니다. 본 서비스에서 회사의 책임은 적법한 동의 기반의 수집 및 안전한 정보 제공 시스템 운영에 한정되며, 회원이 해당 정보를 제공받아(또는 다운로드하여) 마케팅 등에 직접 활용하는 과정에서 발생하는 제반 민·형사상 책임은 전적으로 회원에게 있습니다본 서비스에서 회사의 책임은 공동 개인정보처리자로서 시스템을 통한 정보의 수집 및 안전한 보관 관리에 한정되며, 회원(고객사)이 해당 정보를 접근(또는 다운로드)하여 마케팅 등에 직접 활용하는 과정에서 발생하는 제반 책임은 회원에게 있습니다. "}
                <span className="badge-new">
                  {"추가"}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="section-card" id="s34">
        <div className="section-head">
          <div className="section-num">
            {"제 34 조"}
          </div>
          <div className="section-title">
            {"분쟁 해결"}
          </div>
        </div>
        <div className="section-body">
          <div className="item-list">
            <div className="item-row">
              <span className="item-num">
                {"(1)"}
              </span>
              <span>
                {"회사와 이용고객간의 통신은 서면, 전자우편, 팩스 등으로 합니다."}
              </span>
            </div>
            <div className="item-row">
              <span className="item-num">
                {"(2)"}
              </span>
              <span>
                {"분쟁으로 소송이 제기될 경우, 대한민국 서울지방법원을 관할법원으로 합니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="chapter-divider" id="addendum">
        <span className="ch-label">
          {"부칙"}
        </span>
        <span className="ch-line"></span>
      </div>
      <div className="section-card">
        <div className="section-body">
          <div className="addendum-box">
            <div className="addendum-row">
              <span className="addendum-num">
                {"(1)"}
              </span>
              <span>
                {"공고일자: 2026.3.31 시행일자: 2026.5.1"}
              </span>
            </div>
            <div className="addendum-row">
              <span className="addendum-num">
                {"(2)"}
              </span>
              <span>
                {"본 '약관'은 2026년 05월 01일부터 시행됩니다."}
              </span>
            </div>
            <div className="addendum-row">
              <span className="addendum-num">
                {"(3)"}
              </span>
              <span>
                {"이전 약관(2024년 8월 시행)은 본 약관 시행과 동시에 폐지합니다."}
              </span>
            </div>
            <div className="addendum-row">
              <span className="addendum-num">
                {"(4)"}
              </span>
              <span>
                {"제2조 (11)·(12), 제2장의2, 제18조 (17), 제31조 (3) ⑬, 제32조 (5), 제33조 (7)은 이번 개정으로 신설된 조항입니다."}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="modal-overlay" id="modalOverlay">
      <div className="modal" id="modal">
        <div className="modal-header">
          <div>
            <h2>
              {"이전 버전 대비 변경사항 요약"}
            </h2>
            <p>
              {"2024년 8월 시행 버전 → 2026년 5월 1일 시행 버전"}
            </p>
          </div>
          <button className="modal-close" data-modal-action="close" type="button">
            {"✕"}
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-section">
            <div className="modal-section-title">
              <span className="num">
                {"1"}
              </span>
              {"이용약관 변경 내용"}
            </div>
            <table className="modal-tbl">
              <thead>
                <tr>
                  <th style={{ width: "32%"  }}>
                    {"조항"}
                  </th>
                  <th>
                    {"변경 내용"}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "600"  }}>
                    {"제2조 (11)·(12)"}
                    <br />
                    <span style={{ fontWeight: "400", fontSize: "11.5px", color: "#888"  }}>
                      {"용어 정의"}
                    </span>
                  </td>
                  <td>
                    {"N-Pass 및 정보주체 용어 신설 "}
                    <span style={{ display: "inline-block", background: "#e8f1ff", color: "#1a6ef5", fontSize: "10px", fontWeight: "700", padding: "2px 7px", borderRadius: "10px", marginLeft: "3px"  }}>
                      {"신설"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600"  }}>
                    {"제18조 (17)"}
                    <br />
                    <span style={{ fontWeight: "400", fontSize: "11.5px", color: "#888"  }}>
                      {"회원의 의무"}
                    </span>
                  </td>
                  <td>
                    {"N-Pass 이용 시 7개 세부 의무 규정 신설 "}
                    <span style={{ display: "inline-block", background: "#e8f1ff", color: "#1a6ef5", fontSize: "10px", fontWeight: "700", padding: "2px 7px", borderRadius: "10px", marginLeft: "3px"  }}>
                      {"신설"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600"  }}>
                    {"제2장의2"}
                    <br />
                    <span style={{ fontWeight: "400", fontSize: "11.5px", color: "#888"  }}>
                      {"N-Pass 서비스"}
                    </span>
                  </td>
                  <td>
                    {"제22조의2~4 전체 신설 (N-Pass 제공, 보안 서약, 이용 제한·해지) "}
                    <span style={{ display: "inline-block", background: "#e8f1ff", color: "#1a6ef5", fontSize: "10px", fontWeight: "700", padding: "2px 7px", borderRadius: "10px", marginLeft: "3px"  }}>
                      {"신설"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600"  }}>
                    {"제31조 (3) ⑬"}
                    <br />
                    <span style={{ fontWeight: "400", fontSize: "11.5px", color: "#888"  }}>
                      {"이용 제한"}
                    </span>
                  </td>
                  <td>
                    {"N-Pass 보안 서약 위반·개인정보 오남용 시 이용 제한 사유 추가 "}
                    <span style={{ display: "inline-block", background: "#e8f6ef", color: "#1a8a4a", fontSize: "10px", fontWeight: "700", padding: "2px 7px", borderRadius: "10px", marginLeft: "3px"  }}>
                      {"추가"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600"  }}>
                    {"제32조 (5)"}
                    <br />
                    <span style={{ fontWeight: "400", fontSize: "11.5px", color: "#888"  }}>
                      {"손해배상"}
                    </span>
                  </td>
                  <td>
                    {"고객사의 N-Pass 개인정보 오남용 시 전적 책임 및 회사 면책 명시 "}
                    <span style={{ display: "inline-block", background: "#e8f6ef", color: "#1a8a4a", fontSize: "10px", fontWeight: "700", padding: "2px 7px", borderRadius: "10px", marginLeft: "3px"  }}>
                      {"추가"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600"  }}>
                    {"제33조 (7)"}
                    <br />
                    <span style={{ fontWeight: "400", fontSize: "11.5px", color: "#888"  }}>
                      {"면책조항"}
                    </span>
                  </td>
                  <td>
                    {"N-Pass 개인정보 활용 과정의 손해에 대한 회사 면책 명시 "}
                    <span style={{ display: "inline-block", background: "#e8f6ef", color: "#1a8a4a", fontSize: "10px", fontWeight: "700", padding: "2px 7px", borderRadius: "10px", marginLeft: "3px"  }}>
                      {"추가"}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="modal-section">
            <div className="modal-section-title">
              <span className="num">
                {"2"}
              </span>
              {"고객사 주요 준수 사항 (N-Pass 이용 시)"}
            </div>
            <ul className="check-list">
              <li>
                <span className="icon">
                  {"▸"}
                </span>
                <span>
                  {"관리자 계정 "}
                  <strong>
                    {"2단계 인증(MFA)"}
                  </strong>
                  {" 필수 설정 및 접근 권한 최소화"}
                </span>
              </li>
              <li>
                <span className="icon">
                  {"▸"}
                </span>
                <span>
                  {"개인정보 "}
                  <strong>
                    {"목적 외 사용 금지"}
                  </strong>
                  {" 및 재제공·판매 금지"}
                </span>
              </li>
              <li>
                <span className="icon">
                  {"▸"}
                </span>
                <span>
                  {"다운로드 파일 "}
                  <strong>
                    {"암호화"}
                  </strong>
                  {" 및 사유 기록 의무"}
                </span>
              </li>
              <li>
                <span className="icon">
                  {"▸"}
                </span>
                <span>
                  {"파기 요청 시 "}
                  <strong>
                    {"5일 이내"}
                  </strong>
                  {" 복구 불가능한 방법으로 파기"}
                </span>
              </li>
              <li>
                <span className="icon">
                  {"▸"}
                </span>
                <span>
                  {"서비스 종료 시 보유 개인정보 "}
                  <strong>
                    {"5일 내 전량 파기"}
                  </strong>
                </span>
              </li>
              <li>
                <span className="icon">
                  {"▸"}
                </span>
                <span>
                  {"위반 시 발생하는 "}
                  <strong>
                    {"모든 법적 책임은 고객사 부담"}
                  </strong>
                </span>
              </li>
            </ul>
          </div>
          <div style={{ marginTop: "20px", textAlign: "center"  }}>
            <a href="#" data-route="/clause/use/v1.0" style={{ display: "inline-block", padding: "12px 20px", background: "#1a6ef5", color: "#fff", borderRadius: "8px", textDecoration: "none", fontWeight: "600", fontSize: "13px"  }}>
              {"\n          현재 버전 확인하기\n        "}
            </a>
          </div>
        </div>
      </div>
    </div>
    </ClauseStaticDocument>
  );
};

export default UseV11Document;
